import React, { useState, useEffect } from 'react';
import './Video.css';

import video_production_0 from "../../../asset/video_production_0.svg";
import video_production_1 from "../../../asset/video_production_1.svg";
import video_production_2 from "../../../asset/video_production_2.svg";
import video_production_3 from "../../../asset/video_production_3.svg";
import video_production_4 from "../../../asset/video_production_4.svg";
import video_production_5 from "../../../asset/video_production_5.svg";

import travel_1 from "../../../asset/travel_video_1.svg";
import travel_2 from "../../../asset/travel_video_2.png";
import travel_3 from "../../../asset/travel_video_3.svg";
import travel_4 from "../../../asset/travel_video_4.svg";

import music_1 from "../../../asset/music_video_1.png";
import music_2 from "../../../asset/music_video_2.png";
import music_3 from "../../../asset/music_video_3.svg";
import music_4 from "../../../asset/music_video_4.png";
import music_5 from "../../../asset/music_video_5.svg";
import music_6 from "../../../asset/music_video_6.svg";
import music_7 from "../../../asset/music_video_7.png";

import commercial_1 from "../../../asset/commercial_1.png";
import commercial_2 from "../../../asset/commercial_2.png";
import commercial_3 from "../../../asset/commercial_3.svg";
import commercial_4 from "../../../asset/commercial_4.svg";
import commercial_5 from "../../../asset/commercial_5.png";

import interview_1 from "../../../asset/interview_1.svg";
import interview_2 from "../../../asset/interview_2.png";
import interview_3 from "../../../asset/interview_3.svg";
import interview_4 from "../../../asset/interview_4.png";

import news_1 from "../../../asset/news_1.png";
import news_2 from "../../../asset/news_2.png";
import news_3 from "../../../asset/news_3.png";
import news_4 from "../../../asset/news_4.png";
import news_5 from "../../../asset/news_5.png";
import news_6 from "../../../asset/news_6.png";
import news_7 from "../../../asset/news_7.svg";

import short_1 from "../../../asset/short_film_1.png";
import short_2 from "../../../asset/short_film_2.svg";
import short_3 from "../../../asset/short_film_3.png";
import short_4 from "../../../asset/short_film_4.png";

import red_dot from "../../../asset/main-projects.svg";
import purple_dot from "../../../asset/purple_dot.svg";
import yellow_dot from "../../../asset/toy-projects.svg";
import skyblue_dot from "../../../asset/skyblue_dot.svg";
import green_dot from "../../../asset/series-works.svg";
import pink_dot from "../../../asset/pink_dot.svg";

import select_background from "../../../asset/video_select_background_image.png";
import click_the_image from "../../../asset/click_the_image_to_watch.svg";

import x from "../../../asset/x.svg";

// import camera_ani_1 from "../../../asset/camera_ani_1.svg";
// import camera_ani_2 from "../../../asset/camera_ani_2.svg";
// import camera_ani_3 from "../../../asset/camera_ani_3.svg";
// import camera_ani_4 from "../../../asset/camera_ani_4.svg";
// import camera_ani_5 from "../../../asset/camera_ani_5.svg";
// import camera_ani_6 from "../../../asset/camera_ani_6.svg";
// import camera_ani_7 from "../../../asset/camera_ani_7.svg";
// import camera_ani_8 from "../../../asset/camera_ani_8.svg";
// import camera_ani_9 from "../../../asset/camera_ani_9.svg";
// import camera_ani_10 from "../../../asset/camera_ani_10.svg";
// import camera_ani_11 from "../../../asset/camera_ani_11.svg";
// import camera_ani_12 from "../../../asset/camera_ani_12.svg";
// import camera_ani_13 from "../../../asset/camera_ani_13.svg";
// import camera_ani_14 from "../../../asset/camera_ani_14.svg";
// import camera_ani_15 from "../../../asset/camera_ani_15.svg";
// import camera_ani_16 from "../../../asset/camera_ani_16.svg";
// import camera_ani_17 from "../../../asset/camera_ani_17.svg";
// import camera_ani_18 from "../../../asset/camera_ani_18.svg";
// import camera_ani_19 from "../../../asset/camera_ani_19.svg";
// import camera_ani_20 from "../../../asset/camera_ani_20.svg";
// import camera_ani_21 from "../../../asset/camera_ani_21.svg";
// import camera_ani_22 from "../../../asset/camera_ani_22.svg";
// import camera_ani_23 from "../../../asset/camera_ani_23.svg";
// import camera_ani_24 from "../../../asset/camera_ani_24.svg";
// import camera_ani_25 from "../../../asset/camera_ani_25.svg";
// import camera_ani_26 from "../../../asset/camera_ani_26.svg";
// import camera_ani_27 from "../../../asset/camera_ani_27.svg";

// const animationImages = [
//     camera_ani_1, camera_ani_2, camera_ani_3, camera_ani_4, camera_ani_5,
//     camera_ani_6, camera_ani_7, camera_ani_8, camera_ani_9, camera_ani_10,
//     camera_ani_11, camera_ani_12, camera_ani_13, camera_ani_14, camera_ani_15,
//     camera_ani_16, camera_ani_17, camera_ani_18, camera_ani_19, camera_ani_20,
//     camera_ani_21, camera_ani_22, camera_ani_23, camera_ani_24, camera_ani_25,
//     camera_ani_26, camera_ani_27
// ];

const video_production = [
    video_production_0, video_production_1, video_production_2,
    video_production_3, video_production_4, video_production_5
];

function Video() {
    const [selectedCell, setSelectedCell] = useState(null);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    // const [currentAnimationIndex, setCurrentAnimationIndex] = useState(0);

    const [isFirstModalOpen, setIsFirstModalOpen] = useState(false); // 모달 상태 추가
    // const [isSecondModalOpen, setIsSecondModalOpen] = useState(false); // 모달 상태 추가

    // 기존 비디오 프로덕션 이미지 로테이션을 위한 useEffect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                (prevIndex + 1) % video_production.length // video_production 이미지 수만큼 반복
            );
        }, 100); // 100ms마다 이미지 전환

        return () => clearInterval(interval);
    }, []);

    // 새로운 애니메이션을 위한 useEffect
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentAnimationIndex((prevIndex) =>
    //             (prevIndex + 1) % animationImages.length // animationImages 이미지 수만큼 반복
    //         );
    //     }, 100); // 100ms마다 이미지 전환

    //     return () => clearInterval(interval); // 컴포넌트 언마운트 시 클리어
    // }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsFirstModalOpen(true);
            // setIsSecondModalOpen(true);
        }, 500);

        return () => clearTimeout(timer); // 컴포넌트가 언마운트될 때 타이머 제거
    }, []);

    const closeFirstModal = () => {
        setIsFirstModalOpen(false); // 모달 닫기
    };

    // const closeSecondModal = () => {
    //     setIsSecondModalOpen(false); // 모달 닫기
    // };

    const handleClick = (index) => {
        setSelectedCell(index); // 클릭한 셀의 인덱스를 저장
    };

    const [blueCellsVideo, setBlueCellsVideo] = useState([]);
    const [blueCellsNewGrid, setBlueCellsNewGrid] = useState([]);

    useEffect(() => {
        const generateRandomBlueCells = (totalCells, numberOfBlueCells) => {
            const generatedBlueCells = new Set();

            while (generatedBlueCells.size < numberOfBlueCells) {
                const randomIndex = Math.floor(Math.random() * totalCells);
                generatedBlueCells.add(randomIndex);
            }

            return Array.from(generatedBlueCells);
        };

        setBlueCellsVideo(generateRandomBlueCells(199, 20)); // grid-container-video 용
        setBlueCellsNewGrid(generateRandomBlueCells(111, 20)); // new-grid-container 용
    }, []);

    // 그리드 칸을 생성 (3x3 그리드 예시)
    const gridItems = Array.from({ length: 199 }, (_, index) => {
        const isBlue = blueCellsVideo.includes(index);
        
        if (index === 13) {
            return (
                <div
                    key={index}
                    className={`grid-item-video travel ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://www.youtube.com/watch?v=ZTIx6Xj0Ii8" target="_blank" rel="noopener noreferrer">   
                        <img
                            src={travel_1}
                            alt="travel-video-1"
                        />
                        <img
                            src={red_dot}
                            alt="travel_videos"
                            className="red-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 14) {
            return (
                <div
                    key={index}
                    className={`grid-item-video travel ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://www.youtube.com/watch?v=cbein3udKgc" target="_blank" rel="noopener noreferrer">
                        <img
                            src={travel_2}
                            alt="travel-video-2"
                        />
                        <img
                            src={red_dot}
                            alt="travel_videos"
                            className="red-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 35) {
            return (
                <div
                    key={index}
                    className={`grid-item-video travel ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://www.youtube.com/watch?v=A_rdoaJbe2s" target="_blank" rel="noopener noreferrer">
                        <img
                            src={travel_3}
                            alt="travel-video-3"
                        />
                        <img
                            src={red_dot}
                            alt="travel_videos"
                            className="red-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 103) {
            return (
                <div
                    key={index}
                    className={`grid-item-video travel1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/sLdSbj3yNPg?si=Siy9Xxj6eKECoHnT" target="_blank" rel="noopener noreferrer">
                        <img
                            src={travel_4}
                            alt="travel-video-4"
                        />
                        <img
                            src={red_dot}
                            alt="travel_videos"
                            className="red-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 40) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/JXJQprRY0WI?si=Q_CpKhRDogz5h3sh" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_2}
                            alt="music_video_2"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 56) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/fc1nc4Q3ZoQ?si=vlSWziuNRPqLgmB-" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_3}
                            alt="music_video_3"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 57) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/2B57AbHwcPg?si=Di-06EUXE8azmGEA" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_4}
                            alt="music_video_4"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 59) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/l0xeVNKh9OY?si=I1t04DYtLncUnRSN" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_1}
                            alt="music_video_1"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 80) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/3ifMIwPDxrc?si=06xbiriVdlWYy6Tt" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_5}
                            alt="music_video_5"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 82) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/vvFHu5yG_7Y?si=cY_vdbdvjej1ya9c" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_6}
                            alt="music_video_6"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 84) {
            return (
                <div
                    key={index}
                    className={`grid-item-video music ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/UHapafzZOlc?si=VteIKpLSUK-pGGeW" target="_blank" rel="noopener noreferrer">
                        <img
                            src={music_7}
                            alt="music_video_7"
                        />
                        <img
                            src={purple_dot}
                            alt="music_videos"
                            className="purple-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 105) {
            return (
                <div
                    key={index}
                    className={`grid-item-video commercial ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/WnV3yfFzw-c?si=ATTaXr_niRTdY_pJ" target="_blank" rel="noopener noreferrer">
                        <img
                            src={commercial_1}
                            alt="commercial_1"
                        />
                        <img
                            src={yellow_dot}
                            alt="commercial_videos"
                            className="yellow-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 106) {
            return (
                <div
                    key={index}
                    className={`grid-item-video commercial ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/jyptN8-PqL4?si=9gxs-l2uJRDwZhqe" target="_blank" rel="noopener noreferrer">
                        <img
                            src={commercial_2}
                            alt="commercial_2"
                        />
                        <img
                            src={yellow_dot}
                            alt="commercial_videos"
                            className="yellow-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 116) {
            return (
                <div
                    key={index}
                    className={`grid-item-video commercial1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/vBeMgr9uVMk?si=57gfyyT3tq-iYL_o" target="_blank" rel="noopener noreferrer">
                        <img
                            src={commercial_3}
                            alt="commercial_3"
                        />
                        <img
                            src={yellow_dot}
                            alt="commercial_videos"
                            className="yellow-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 127) {
            return (
                <div
                    key={index}
                    className={`grid-item-video commercial1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/0FcfOXGFt2s?si=UTOtZYaD81e05A2K" target="_blank" rel="noopener noreferrer">
                        <img
                            src={commercial_4}
                            alt="commercial_4"
                        />
                        <img
                            src={yellow_dot}
                            alt="commercial_videos"
                            className="yellow-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 146) {
            return (
                <div
                    key={index}
                    className={`grid-item-video commercial ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/KT7UqUccbgs?si=c57d0BmPEqsLvtnn" target="_blank" rel="noopener noreferrer">
                        <img
                            src={commercial_5}
                            alt="commercial_5"
                        />
                        <img
                            src={yellow_dot}
                            alt="commercial_videos"
                            className="yellow-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 156) {
            return (
                <div
                    key={index}
                    className={`grid-item-video interview1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/ObV0iHAP10c" target="_blank" rel="noopener noreferrer">
                        <img
                            src={interview_1}
                            alt="interview_1"
                        />
                        <img
                            src={skyblue_dot}
                            alt="interview_videos"
                            className="skyblue-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 157) {
            return (
                <div
                    key={index}
                    className={`grid-item-video interview1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/jRablchwyaw?si=liDuxUkU5md1umqO" target="_blank" rel="noopener noreferrer">
                        <img
                            src={interview_2}
                            alt="interview_2"
                        />
                        <img
                            src={skyblue_dot}
                            alt="interview_videos"
                            className="skyblue-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 169) {
            return (
                <div
                    key={index}
                    className={`grid-item-video interview ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/ns6cFuPi6zs?si=v7voo8JdSEgNclIAE" target="_blank" rel="noopener noreferrer">
                        <img
                            src={interview_3}
                            alt="interview_3"
                        />
                        <img
                            src={skyblue_dot}
                            alt="interview_videos"
                            className="skyblue-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 170) {
            return (
                <div
                    key={index}
                    className={`grid-item-video interview ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/FFQGkhlGAPE?si=pUdFHJpdaiBiDnp8" target="_blank" rel="noopener noreferrer">
                        <img
                            src={interview_4}
                            alt="interview_4"
                        />
                        <img
                            src={skyblue_dot}
                            alt="interview_videos"
                            className="skyblue-dot"
                        />
                    </a>
                </div>
            )
        }

        if (isBlue) {
            return (
                <div
                    key={index}
                    className={`grid-item-new blue ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                    role="button"
                    tabIndex={0}
                >
                    {/* 파란색 셀에 필요한 콘텐츠 추가 가능 */}
                </div>
            );
        }
        
        return (
            <div
                key={index}
                className={`grid-item-video ${selectedCell === index ? 'selected' : ''}`}
                onClick={() => handleClick(index)}
            >
                {/* {index + 1} */}
            </div>
        )
    });

    // 새로운 그리드 아이템 정의
    const newGridItems = Array.from({ length: 111 }, (_, index) => {
        // 특정 인덱스에 따라 다른 콘텐츠를 표시할 수 있습니다.
        const isBlue = blueCellsNewGrid.includes(index);

        if (index === 12) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/E976hYP-mnA?si=1UpJ0Gq8s11l2sYn" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_1}
                            alt="news_1"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 14) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/KIlWGSXqkvc?si=JOI3BxaS9Qe3Yg8N" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_3}
                            alt="news_3"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 25) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/tRHppVqZYnk?si=kaKSNV0640iU-YBh" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_2}
                            alt="news_2"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 28) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/jFY7jCQa-n8?si=r-idVb6tokGrgMcC" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_4}
                            alt="news_4"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 40) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/MTdXXB8Cd-0?si=M3Z7_kNgNf0nM8QL" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_6}
                            alt="news_6"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 43) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/nQ3RopWjjZc?si=eJA1jJtX3WC1bw52" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_5}
                            alt="news_5"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 54) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new news1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtube.com/playlist?list=PLFr5yms3QqaxM3LEoTnf0ZslSCImHrY5H&si=NPu_f8ufqv7klcAx" target="_blank" rel="noopener noreferrer">
                        <img
                            src={news_7}
                            alt="news_7"
                        />
                        <img
                            src={green_dot}
                            alt="news_videos"
                            className="green-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 69) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new short ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/LgSvgmOSmTE?si=iGeqERARUherQD-t" target="_blank" rel="noopener noreferrer">
                        <img
                            src={short_1}
                            alt="short_1"
                        />
                        <img
                            src={pink_dot}
                            alt="short_films"
                            className="pink-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 73) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new short ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/eRWVkKdWOfo?si=oKz6kv_TXho_d_Ko" target="_blank" rel="noopener noreferrer">
                        <img
                            src={short_2}
                            alt="short_2"
                        />
                        <img
                            src={pink_dot}
                            alt="short_films"
                            className="pink-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 88) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new short1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/7UN093AIaXA?si=VUMytsz4oF_C5_Ji" target="_blank" rel="noopener noreferrer">
                        <img
                            src={short_3}
                            alt="short_3"
                        />
                        <img
                            src={pink_dot}
                            alt="short_films"
                            className="pink-dot"
                        />
                    </a>
                </div>
            )
        } else if (index === 89) { // 예시: 특정 인덱스에 특별한 스타일이나 링크 추가
            return (
                <div
                    key={index}
                    className={`grid-item-new short1 ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <a href="https://youtu.be/kZVOBGKj0kc?si=7YNGI8NBM_IgrWP7" target="_blank" rel="noopener noreferrer">
                        <img
                            src={short_4}
                            alt="short_4"
                        />
                        <img
                            src={pink_dot}
                            alt="short_films"
                            className="pink-dot"
                        />
                    </a>
                </div>
            )
        }
    
        if (isBlue) {
            return (
                <div
                    key={index}
                    className={`grid-item-new blue ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                    role="button"
                    tabIndex={0}
                >
                    {/* 파란색 셀에 필요한 콘텐츠 추가 가능 */}
                </div>
            );
        }

        return (
            <div
                key={index}
                className={`grid-item-new ${selectedCell === index ? 'selected' : ''}`}
                onClick={() => handleClick(index)}
            >
                {/* {index + 1} */}
            </div>
        )
    });

    return (
        <div
            className="video-container"
        >
            <div className="grid-container-video">
                {gridItems}
            </div>

            <div className="animation-container">
                <div className="video_production">
                    <img
                        className="video_production_rotating"
                        src={video_production[currentImageIndex]}
                        alt={`video_production_${currentImageIndex + 1}`}
                    />
                </div>

                <div className="new-grid-container">
                    {newGridItems}
                </div>
            </div>


            {isFirstModalOpen && (
                <div className="video-modal-container">
                    <div className="video-modal-upper">
                        <img
                            src={x}
                            alt={"x"}
                            onClick={closeFirstModal}
                            className="video-modal-upper-x"
                            style={{
                                width: "auto",
                                height: "20px",
                                margin: "2%"
                            }}
                        />
                    </div>
                    <div className="video-modal-lower">
                        <img
                            src={select_background}
                            alt={"background_image"}
                            style={{
                                width: "100%",
                                height: "auto",
                                paddingTop: "1%",
                                opacity: "40%"
                                // borderBottomLeftRadius: "15px",
                                // borderBottomRightRadius: "15px",
                            }}
                        />
                        <img
                            src={click_the_image}
                            alt={"click-the-image"}
                            style={{
                                width: "80%",
                                height: "60%",
                                position: "absolute",
                                left: "10%",
                                top: "20%"
                            }}
                        />
                    </div>
                    <div className="video-modal-bottom">
                    </div>
                </div>
            )}
        </div>
    );
}

export default Video;